import { useStore } from '@nanostores/react';
import { memo, useCallback, type UIEvent } from 'react';
import { toast } from 'react-toastify';
import { DeleteChatDialogContent } from '~/components/ui/DeleteChatDialogContent';
import { Dialog } from '~/components/ui/Dialog';
import { chatStore } from '~/lib/stores/chat';
import { descriptionStore } from '~/lib/stores/description';
import { projectStore } from '~/lib/stores/project';
import { logger } from '~/utils/logger';

export const DeleteChat = memo(({ open, onClose }: { open: boolean; onClose: VoidFunction }) => {
  const description = useStore(descriptionStore);

  const deleteCurrentChat = useCallback(async (event: UIEvent) => {
    event.preventDefault();

    try {
      const currentProjectId = projectStore.getProjectId();

      if (!currentProjectId) {
        toast.error('No project selected');
        return;
      }

      const currentChatItem = chatStore.findChatByProjectId(currentProjectId);

      if (!currentChatItem) {
        toast.error('No chat found for the current project');
        return;
      }

      await chatStore.removeChat(currentChatItem);

      window.location.pathname = '/';
      toast.success('Chat deleted');
    } catch (error) {
      toast.error('Failed to delete chat');
      logger.error(error);
    }
  }, []);

  const handleDeleteChat = useCallback(
    (event: UIEvent) => {
      deleteCurrentChat(event);
      onClose();
    },
    [deleteCurrentChat, onClose],
  );

  return (
    <>
      <Dialog open={open} onClose={onClose} contentClassName="selection-accent max-w-md">
        <DeleteChatDialogContent
          itemDescription={description || 'Untitled'}
          onDeleteItem={handleDeleteChat}
          onClose={onClose}
        />
      </Dialog>
    </>
  );
});

DeleteChat.displayName = 'DeleteChatDialog';
